/* eslint-disable no-undef */

//const WORK_DAY=8;
const cap = {};
export default class GanttUtils{
     static getAllocatedValue(tasks, resource) {
        let result = 0;
        tasks.forEach(function (item) {
            const assignments = gantt.getResourceAssignments(resource.id, item.id);
            assignments.forEach(function (assignment) {
                if (gantt.$resourceMode == "hours") {
                    result += Number(assignment.value);
                }
                else {
                    ++result;
                }
            });
        });
        return result;
    }
static getCapacity(date, endDate,resource) {

    if (gantt.$resourcesStore.hasChild(resource.id)) {
        return -1;
    }
    let val = date.valueOf();
    if (gantt.$resourceMode == "hours") {
        return cap[val + resource.id]=8;
    }else{
        return 1;
    }
    
}
static  getResourceAssignments(resourceId) {
    let assignments;
    const store = gantt.getDatastore(gantt.config.resource_store);
    if (store.hasChild(resourceId)) {
        assignments = [];
        store.getChildren(resourceId).forEach(function (childId) {
            assignments = assignments.concat(gantt.getResourceAssignments(childId));
        });
    } else {
        assignments = gantt.getResourceAssignments(resourceId);
    }
    return assignments;
}

}